import { Injectable, signal } from '@angular/core'

@Injectable({
   providedIn: 'root',
})
export class RetryConnectionService {
   messages = signal<any>(undefined)

   addMessages(type: 'success' | 'warn' | 'error', content: string) {
      this.messages.set({ severity: type, content: content })
   }

   clearMessages() {
      this.messages.set(undefined)
   }
}
